module.exports = __webpack_public_path__ + "a343b1aa39dbcbe939f1d54e0b693252.pdf";